<template>
  <v-dialog
    :value="value"
    max-width="600"
    persistent
    overlay-color="var(--ds-color-reverse)"
    @input="closeDialog"
  >
    <v-card>
      <v-card-title>
        {{ modalTitle }}
      </v-card-title>
      <v-card-text>
        {{ modalMessage }}
      </v-card-text>
      <v-card-actions class="ds-padding-stack--xs">
        <v-spacer />
        <DsButton
          color="secondary"
          :disabled="isSaving"
          @click="closeDialog"
        >
          {{ cancelLabel }}
        </DsButton>
        <DsButton
          class="ds-margin-left-stack--xs"
          :disabled="isSaving"
          :loading="isSaving"
          @click="confirm"
        >
          {{ cardLabel }}
        </DsButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sleep } from '@/utils/sleep';
import { DsButton } from '@ds/components';

export default {
  name: 'CardModal',
  components: {
    DsButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    cancelLabel: {
      type: String,
      default() {
        return this.$t('components.CardModal.label.cancelLabel');
      },
    },
    cardLabel: {
      type: String,
      default() {
        return this.$t('components.CardModal.label.cardLabel');
      },
    },
    modalTitle: {
      type: String,
      default() {
        return this.$t('components.CardModal.label.modalTitle');
      },
    },
    modalText: {
      type: String,
      default() {
        return this.$t('components.CardModal.label.modalText');
      },
    },
    componentName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSaving: false,
      emitConfirmDelay: 100,
      notSavingDelay: 2000,
    };
  },
  computed: {
    modalMessage() {
      return this.componentName ? `${this.modalText} "${this.componentName}"?` : `${this.modalText}?`;
    },
  },
  methods: {
    async confirm() {
      this.isSaving = true;

      await sleep(this.emitConfirmDelay);
      this.$emit('confirm');

      await sleep(this.notSavingDelay);
      this.isSaving = false;
    },
    closeDialog() {
      this.$emit('input', false);
    },
  },
};
</script>
